var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopyButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Copy button",
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 46
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle Copy 9",
  fill: "#fff",
  stroke: "current",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 45,
  height: 45,
  rx: 3.5,
  fill: "none"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Copy Icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.854 17.213H15.928A1.928 1.928 0 0 0 14 19.141v10.926a1.928 1.928 0 0 0 1.928 1.928h10.926a1.928 1.928 0 0 0 1.928-1.928V19.141a1.928 1.928 0 0 0-1.928-1.928Z",
  fill: "#fff",
  stroke: "#376996",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path",
  d: "M30.071 14H18.499a1.928 1.928 0 0 0-1.928 1.928.643.643 0 1 0 1.285 0 .643.643 0 0 1 .643-.643h11.572a.643.643 0 0 1 .643.643V27.5a.643.643 0 0 1-.643.643.643.643 0 0 0 0 1.285 1.928 1.928 0 0 0 1.924-1.928V15.928A1.928 1.928 0 0 0 30.071 14Z",
  fill: "#376996"
}))));
export default SvgCopyButton;